// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface BackupDump
 */
export interface BackupDump {
  /**
   *
   * @type {string}
   * @memberof BackupDump
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof BackupDump
   */
  timestamp?: string;
}

/**
 * Check if a given object implements the BackupDump interface.
 */
export function instanceOfBackupDump(value: object): value is BackupDump {
  return true;
}

export function BackupDumpFromJSON(json: any): BackupDump {
  return BackupDumpFromJSONTyped(json, false);
}

export function BackupDumpFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): BackupDump {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    timestamp: json['timestamp'] == null ? undefined : json['timestamp'],
  };
}

export function BackupDumpToJSON(json: any): BackupDump {
  return BackupDumpToJSONTyped(json, false);
}

export function BackupDumpToJSONTyped(
  value?: BackupDump | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value['id'],
    timestamp: value['timestamp'],
  };
}
